export let exportMenu = [
	{
		icon: "uil-clipboard-notes sidebar-icon",
		children: [
			{
				title: true,
				i18n: "documents",
			},
			{
				url: "/production-board",
				permission: "sec.production_board",
				i18n: "production_board",
				icon: "uil-apps",
			},
			{
				url: "/documents-in",
				permission: "sec.documents_in",
				i18n: "good_reception",
				icon: "uil-bring-front",
			},
			{
				url: "/documents-preparation",
				permission: "sec.documents_preparation",
				i18n: "preparation",
				icon: "uil-apps",
				active: false,
			},
			{
				url: "/write-off",
				permission: "sec.write_off",
				i18n: "write_off",
				icon: "uil-trash-alt",
				active: false,
			},
			{
				url: "/inventory",
				permission: "sec.inventory",
				i18n: "inventory",
				icon: "uil-clipboard-alt",
				active: false,
			},
			{
				title: true,
				i18n: "reports",
			},
			{
				url: "/report/dashboard",
				permission: "sec.report_dashboard",
				i18n: "home",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/summary",
				permission: "sec.report_summary",
				i18n: "summary_report",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/shifts",
				permission: "sec.report_shifts",
				i18n: "shifts",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/manager-reports",
				permission: "sec.report_shifts",
				i18n: "manager_reports",
				icon: "uil-file-info-alt",
			},
			{
				url: "/report/z-report",
				permission: "sec.report_z_report",
				i18n: "z_report",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/documents-in",
				permission: "sec.report_documents_in",
				i18n: "good_reception",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/documents-preparation",
				permission: "sec.report_documents_preparation",
				i18n: "preparation",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/sales",
				permission: "sec.report_sales",
				i18n: "sales",
				icon: "uil-chart-pie-alt",
			},
			{
				// Chekni SOTUVCHI yozadi (cashier_login = chekni yozgan odam); pulni kassir
				// ₴ tugmasi orqali oladi (ADR-007). Shu sababli hisobot nomi «Sotuvchilar».
				// URL va ruxsat nomi o'zgarmadi — eski havolalar va tarif sozlamalari ishlashda davom etadi.
				url: "/report/cashiers",
				permission: "sec.report_cashiers",
				i18n: "sellers",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/expenses",
				permission: "sec.report_expenses",
				i18n: "income_expense",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/rasxodlar",
				permission: "sec.report_rasxodlar",
				i18n: "expenses_by_worker",
				icon: "uil-money-bill",
			},
			{
				url: "/report/gross-income",
				permission: "sec.report_gross_income",
				i18n: "gross_income",
				icon: "uil-chart-pie-alt",
				active: false,
			},
			{
				url: "/cashbox/pending-orders",
				permission: "sec.cashbox_pending_orders",
				i18n: "pending_orders",
				icon: "uil-clock",
				active: false,
			},
			{
				url: "/report/returns",
				permission: "sec.report_returns",
				i18n: "returns_report",
				icon: "uil-redo",
			},
			{
				url: "/report/deleted-cheques",
				permission: "sec.report_deleted_cheques",
				i18n: "deleted_cheques",
				icon: "uil-trash-alt",
			},
			{
				url: "/report/deleted-expenses",
				permission: "sec.report_deleted_expenses",
				i18n: "deleted_expenses",
				icon: "uil-receipt-alt",
			},
			{
				title: true,
				i18n: "debit_credit",
			},
			{
				url: "/report-suppliers",
				permission: "sec.report_suppliers",
				i18n: "suppliers",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report-clients",
				permission: "sec.report_clients",
				i18n: "clients",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report/debt-monitoring",
				permission: "sec.report_debt_monitoring",
				i18n: "debt_monitoring",
				icon: "uil-clock-three",
			},
			{
				title: true,
				i18n: "warehouses",
			},
			{
				url: "/report-balance",
				permission: "sec.report_balance",
				i18n: "balance2",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/report-balance-2",
				permission: "sec.report_balance_2",
				i18n: "balance_by_category",
				icon: "uil-chart-pie-alt",
			},
			{
				url: "/warehouse-rolls",
				permission: "sec.warehouse_rolls",
				i18n: "warehouse_rolls",
				icon: "uil-archive",
			},
			{
				url: "/warehouse-products",
				permission: "sec.warehouse_products",
				i18n: "warehouse_products",
				icon: "uil-archive",
			},
			{
				url: "/warehouse-finished",
				permission: "sec.warehouse_finished",
				i18n: "warehouse_finished",
				icon: "uil-archive",
			},
			{
				url: "/stock-levels",
				permission: "sec.warehouse_finished",
				i18n: "stock_levels",
				icon: "uil-shield-check",
			},
			{
				url: "/supplier-orders",
				permission: "sec.supplier_orders",
				i18n: "supplier_orders",
				icon: "uil-telegram",
			},

		]
	},
	{
		icon: "uil-chart-bar sidebar-icon",
		children: [
			{
				title: true,
				i18n: "analytics",
			},
			{
				url: "/analytics/dashboard",
				permission: "sec.analytics_dashboard",
				i18n: "analytics_dashboard",
				icon: "uil-chart-pie-alt",
				active: false,
			},
			{
				url: "/analytics/customer",
				permission: "sec.analytics_customer",
				i18n: "customer_analytics",
				icon: "uil-users-alt",
				active: false,
			},
			{
				/* Mijoz shikoyat/takliflari — bot orqali keladi.
				   Mijozlar tahlili yonida turibdi (ikkisi ham mijoz haqida).
				   Boshqa joy ma'qul bo'lsa — ayting, ko'chiraman. */
				url: "/complaints",
				permission: "sec.complaints",
				i18n: "complaints",
				icon: "uil-comment-alt-exclamation",
				active: false,
			},
			{
				url: "/analytics/unit",
				permission: "sec.analytics_unit",
				i18n: "unit_dashboard",
				icon: "uil-building",
				active: false,
			},
			{
				url: "/analytics/expenses",
				permission: "sec.analytics_expenses",
				i18n: "expense_dashboard",
				icon: "uil-invoice",
				active: false,
			},
			{
				url: "/analytics/monthly-report",
				permission: "sec.analytics_monthly_report",
				i18n: "monthly_report",
				icon: "uil-file-alt",
				active: false,
			},
			{
				url: "/analytics/reorder",
				permission: "sec.analytics_reorder",
				i18n: "reorder_title",
				icon: "uil-shopping-cart-alt",
				active: false,
			},
			{
				url: "/analytics/abc-products",
				permission: "sec.analytics_abc_products",
				i18n: "abc_products",
				icon: "uil-cell",
				active: false,
			},
			{
				url: "/analytics/frozen",
				permission: "sec.analytics_frozen",
				i18n: "frozen_title",
				icon: "uil-snowflake",
				active: false,
			},
			{
				url: "/analytics/abc-xyz",
				permission: "sec.analytics_abc_xyz",
				i18n: "abc_xyz_title",
				icon: "uil-apps",
				active: false,
			},
			{
				url: "/analytics/daily-dashboard",
				permission: "sec.analytics_daily_dashboard",
				i18n: "daily_dashboard",
				icon: "uil-layer-group",
				active: false,
			},
			{
				url: "/report/roll-profit",
				permission: "sec.report_roll_profit",
				i18n: "roll_profit",
				icon: "uil-layer-group",
				active: false,
			},
			{
				url: "/report/roll-prices",
				permission: "sec.report_roll_prices",
				i18n: "roll_prices",
				icon: "uil-chart-line",
				active: false,
			},
			// Video-analitika (kamera/AI) — hozircha «tez kunda» sahifasi.
			// Ma'lumot zavoddagi Vision serveridan keladi: docs/adr/ADR-012-vision-app-split.md
			{
				url: "/analytics/video",
				permission: "sec.analytics_video",
				i18n: "video_analytics",
				icon: "uil-video",
				active: false,
			},
		]
	},
	{
		icon: "uil-users-alt sidebar-icon",
		children: [
			{
				title: true,
				i18n: "employees",
			},
			{
				url: "/employees",
				permission: "sec.employees",
				i18n: "employees",
				icon: "uil-users-alt",
			},
			{
				url: "/employee-account",
				permission: "sec.employee_account",
				i18n: "employee_account",
				icon: "uil-transaction",
			},
			{
				url: "/kpi",
				permission: "sec.kpi",
				i18n: "kpi",
				icon: "uil-chart-line",
			},
			{
				url: "/attendance",
				permission: "sec.attendance",
				i18n: "attendance",
				icon: "uil-calendar-alt",
			},
			{
				url: "/employees-types",
				permission: "sec.employees_types",
				i18n: "positions",
				icon: "uil-list-ui-alt",
			},
			{
				url: "/departments",
				permission: "sec.departments",
				i18n: "departments",
				icon: "uil-web-grid-alt",
			},
		]
	},
	{
		icon: "uil-setting sidebar-icon",
		children: [
			{
				title: true,
				i18n: "settings",
			},
			{
				url: "/pos",
				permission: "sec.pos",
				i18n: "pos",
				icon: "uil-shop",
				active: false,
			},
			{
				url: "/products",
				permission: "sec.products",
				i18n: "products",
				icon: "uil-shopping-cart",
				active: false,
			},
			{
				// Chizma moduli bilan keladi — tarifda bo'lmasa menyuda ko'rinmaydi
				url: "/accessory-drawings",
				permission: "sec.accessory_drawing",
				i18n: "accessory_drawings",
				icon: "uil-ruler-combined",
				active: false,
			},
			{
				url: "/production-capacity",
				permission: "sec.production_capacity",
				i18n: "production_capacity",
				icon: "uil-tachometer-fast-alt",
				active: false,
			},
			{
				url: "/product-statuses",
				permission: "sec.product_statuses",
				i18n: "product_statuses",
				icon: "uil-shopping-cart",
				active: false,
			},
			{
				url: "/wms",
				permission: "sec.wms",
				i18n: "warehouse",
				icon: "uil-store",
				active: false,
			},
			{
				url: "/clients",
				permission: "sec.clients",
				i18n: "clients",
				icon: "uil-user",
				active: false,
			},
			{
				url: "/clients-types",
				permission: "sec.clients_types",
				i18n: "client_types",
				icon: "uil-user",
				active: false,
			},
			{
				url: "/regions",
				permission: "sec.regions",
				i18n: "regions",
				icon: "uil-map-marker",
				active: false,
			},
			{
				url: "/units",
				permission: "sec.units",
				i18n: "units",
				icon: "uil-cell",
			},
			{
				url: "/payment-types",
				permission: "sec.payment_types",
				i18n: "payment_types",
				icon: "uil-transaction",
				active: false,
			},
			{
				url: "/payment-purposes",
				permission: "sec.payment_purposes",
				i18n: "income_expense",
				icon: "uil-coins",
			},
			{
				// Chiqim guruhlari — «Кирим/Чиким» ning yonida, chunki modda shu
				// guruhga biriktiriladi. Ruxsat ham o'shaniki (alohida galochka
				// qo'shsak, guruh ko'rinmay modda tanlanmay qolardi).
				url: "/payment-purpose-groups",
				permission: "sec.payment_purposes",
				i18n: "pl_groups",
				icon: "uil-layer-group",
			},
			{
				url: "/categories",
				permission: "sec.categories",
				i18n: "categories",
				icon: "uil-web-section-alt",
			},
			{
				url: "/delivery-types",
				permission: "sec.delivery_types",
				i18n: "delivery_type",
				icon: "uil-truck",
			},
			{
				url: "/suppliers",
				permission: "sec.suppliers",
				i18n: "suppliers",
				icon: "uil-truck-loading",
			},
			{
				url: "/currency",
				permission: "sec.currency",
				i18n: "currency",
				icon: "uil-transaction",
			},
			{
				url: "/accounts",
				permission: "sec.accounts",
				i18n: "accounts",
				icon: "uil-moneybag",
			},
			{
				url: "/cheque-note-settings",
				permission: "sec.cheque_note_settings",
				i18n: "cheque_note_settings",
				icon: "uil-receipt-alt",
			},
			{
				url: "/urgent-settings",
				permission: "sec.urgent_settings",
				i18n: "urgent_settings",
				icon: "uil-bolt",
			},
		]
	},
	{
		icon: "uil-plug sidebar-icon",
		children: [
			{
				title: true,
				i18n: "external_services",
			},
			{
				url: "/attendance-setup",
				permission: "sec.attendance_setup",
				i18n: "attendance_setup",
				icon: "uil-clock",
			},
			{
				url: "/hikvision-devices",
				permission: "sec.hikvision_devices",
				i18n: "hikvision_devices",
				icon: "uil-camera",
			},
			{
				url: "/telegram-settings",
				permission: "sec.telegram_settings",
				i18n: "telegram_settings",
				icon: "uil-telegram",
			},
			{
				url: "/sms-settings",
				permission: "sec.broadcast",
				i18n: "sms_integration",
				icon: "uil-comment-alt-message",
			},
			{
				url: "/crm-settings",
				permission: "sec.crm_settings",
				i18n: "crm_integration",
				icon: "uil-database-alt",
			},
		]
	},
]